import { createReducer } from '@reduxjs/toolkit';
import isNil from 'lodash/isNil';

import { UPDATE_LANGUAGE } from 'constants/redux-actions';

const initState = {
  loaded: false,
  selectedLang: null,
};

const langReducer = createReducer(initState, {
  [UPDATE_LANGUAGE]: (prevState, action) => {
    const loaded = !isNil(action.payload);

    return {
      loaded,
      selectedLang: loaded ? action.payload : prevState.selectedLang,
    };
  },
});

export default langReducer;
